<template>
  <div class="vabHeader">
    <a-layout-header class="vab-header">
      <a-row justify="space-between">
        <span>
          <MenuUnfoldOutlined v-if="collapsed" class="trigger" @click="toggleCollapse" />
          <MenuFoldOutlined v-else class="trigger" @click="toggleCollapse" />
        </span>
        <a-space :size="6" style="margin-right: 0.8em">
          <a-button v-if="!memberInfo?.shop_name" type="primary" style="margin-right: 3px" @click="showLoginModal"
            >登录</a-button
          >
          <KefuBtn />
          <!-- 选择店群 -->
          <div v-if="mallGroupList[0]?.GroupId">
            <span class="label">请选择店群: </span>
            <a-select ref="select" v-model:value="GroupId" style="width: 120px" @change="changeMallGroup">
              <a-select-option :value="item.GroupId" v-for="item in mallGroupList" :key="item.Id">{{
                item.GroupName
              }}</a-select-option>
            </a-select>
          </div>
          <!-- <template v-if="memberInfo?.shop_name">
            <div style="display: flex; align-items: center; margin-right: 30px; margin-left: 5px">
              <img class="shopImg" src="~@/assets/user.png" />
              <span class="shopName">{{ memberInfo.shop_name }}</span>
            </div>
          </template> -->
          <a-popover v-if="memberInfo?.shop_name" title="个人信息">
            <template #content>
              <div
                v-for="item in mallList"
                :key="item.Id"
                class="mall_item"
                :class="{ active_mall: item.Id == checkMall.Id }"
              >
                <span> {{ item.auth.ShopName }}</span>
                <a-button v-if="item.Id != checkMall.Id" size="small" type="primary" @click="changeMall(item)">
                  切换
                </a-button>
              </div>
              <a-button block type="primary" danger @click="logout"> 退出登录 </a-button>
            </template>
            <div style="margin-right: 40px">
              <img class="shopImg" src="~@/assets/user.png" alt="" />
              <span class="shopName"
                >{{ checkMall && checkMall.auth ? checkMall.auth.ShopName : memberInfo.shop_name }} <CaretDownOutlined
              /></span>
            </div>
          </a-popover>
        </a-space>
      </a-row>
      <CheckAuth ref="checkAuth" />
    </a-layout-header>
  </div>
</template>
<script>
import CheckAuth from "@/views/base/components/check_auth";
import KefuBtn from "@/views/base/components/kefu_btn";
import { MenuUnfoldOutlined, MenuFoldOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
import handler from "./handler";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Service_GetZfbMemberInfo } from "@/service/platform_config";
import { Service_SetDefaultAppToLocal, Service_GetBranchRelId } from "@/service/branch_relId_service";
export default {
  props: {
    collapsed: Boolean,
  },
  data() {
    return {
      memberInfo: {},
      checkMallGroup: {}, //当前店群
    };
  },
  components: {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    CaretDownOutlined,
    KefuBtn,
    CheckAuth,
  },
  computed: {
    ...mapGetters({
      mallGroupList: "mall_group/mallGroupList",
      mallList: "mall_group/mallList",
      GroupId: "mall_group/GroupId",
      checkMall: "mall_group/checkMall",
    }),
  },
  methods: {
    ...mapActions({
      GetMallGroupList: "mall_group/GetMallGroupList",
    }),
    ...mapMutations({
      setGroupId: "mall_group/setGroupId",
      setMallList: "mall_group/setMallList",
      setCheckMall: "mall_group/setCheckMall",
      setNavList: "xfadmin/setNavList",
    }),
    toggleCollapse() {
      this.$emit("ToggleCollapse");
    },
    logout() {
      handler.LogOut(() => {
        this.init();
        this.$message.success("退出成功!");
        location.reload();
      });
    },
    async init() {
      this.memberInfo = await Service_GetZfbMemberInfo();
      const { resourceList, navList } = await handler.GetResourceList();
      this.resourceList = resourceList;
      this.setNavList(navList);
      await this.GetMallGroupList();
      if (!this.GroupId && this.mallGroupList && this.mallGroupList.length) {
        this.checkMallGroup = this.mallGroupList[0];
        this.setGroupId(this.mallGroupList[0]?.GroupId || "");
        this.getMallList();
      }
    },
    //获取店铺列表
    async getMallList() {
      if (this.checkMallGroup?.GroupId) {
        var { mallList, success, msg } = await handler.GetMallListByGroupId(1, 100, this.checkMallGroup.GroupId);
        if (!success) {
          this.$message.warn(`获取授权店铺列表数据失败，原因:【${msg}】`);
        } else {
          this.setMallList(mallList);
          this.setCheckMall(mallList?.[0]);
          for (let i = 0; i < mallList.length; i++) {
            // var { msg2 as msg, success2 as success, authMallList } = await handler.GetAuthAppList(
            var data = await handler.GetAuthAppList(1, 100, mallList[i].isSingle ? "" : mallList[i].Id);
            if (!data.success) this.$message.warn(data.msg);
            this.checkIsHasDefaultInLocal(mallList[i], data.authMallList);
          }
        }
      }
    },
    //保存店铺授权信息
    checkIsHasDefaultInLocal(record, authMallList) {
      if (!authMallList.length) return;
      // 从本地获取 RelId
      var branchRelId = Service_GetBranchRelId(record);
      const auth =
        authMallList.find((res) => {
          return res.RelId == branchRelId;
        }) || authMallList[0];
      // 如果获取不到那么,就默认将第一个设置成默认的
      //  Service_SetDefaultAppToLocal(record, authMallList[0]);
      Service_SetDefaultAppToLocal(record, auth);
      //   this.branchRelId = branchRelId;
    },
    //切换店铺
    changeMall(item) {
      this.setCheckMall(item);
    },
    //切换店群的时候重新刷新列表
    changeMallGroup(val) {
      const filterGroup = this.mallGroupList.filter((res) => {
        return res.GroupId == val;
      });
      this.checkMallGroup = filterGroup[0];
      this.setGroupId(val);
      this.getMallList();
      this.$message.success("已成功为您切换店群!");
    },
    showLoginModal() {
      this.$refs.checkAuth.$refs.loginModal.show();
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
@import "./index";
</style>
